<template>
  <v-container fluid class="salessummary-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row align="center" no-gutters>
            <v-col v-if="query.userid!=null" cols="12" md="3" class="d-flex justify-space-between justify-md-start">
                <div>
                  <v-avatar v-if="users.find(user=>user._id == query.userid)['userimage']!==''" size="40">
                    <img v-bind:src="users.find(user=>user._id == query.userid)['userimage']" alt="">
                  </v-avatar>
                  <v-avatar v-else color="warning" size="40">
                    <span class="white--text headline">{{ users.find(user=>user._id == query.userid)['username'][0].toUpperCase() }}</span>
                  </v-avatar>
                  <span style="margin-left:15px">{{ users.find(user=>user._id == query.userid)['username'] }}</span>
                </div>
            </v-col>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-start">
              <div>
                <div style="display: block; margin: 0;" v-if="query.regionid!=null"><span><b>Region:</b> {{ regions.find(region=>region._id == query.regionid)['regionname'] }}</span></div> 
                <div style="display: block; margin: 0;" v-if="query.townshipid!=null"><span><b>Township:</b> {{ townships.find(township=>township._id == query.townshipid)['townshipname'] }}</span></div> 
                <div style="display: block; margin: 0;" v-if="query.startdate!=null || query.enddate!=null"><b>Date Range:</b> {{ query.startdate }} - {{ query.enddate }}</div> 
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-end">
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="findSalesSummaryDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="salessummaries.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="salessummaries-table"
              single-select
              item-key="_id"
              sort-by="salessummaryname"
              :footer-props="footer"
              :headers="headers"
              :items="salessummaries"
              :items-per-page="itemPerPage">
              <template v-slot:item.customername="{ item }">
                <p class="two-line">{{ item.customername  }}</p>
                <p class="two-line">{{ item.customeraddress  }}</p>
                <p v-if="item.regionid!=undefined && item.townshipid!=undefined" class="two-line">{{ regions.length>0 ? regions.find(region=>region._id == item.regionid)['regionname'] : ''  }} - {{ townships.length>0 ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }} - {{ item.customertype }}</p>
              </template>
              <template v-slot:item.customerthumbnail="{ item }">
                <v-img aspect-ratio="1" v-bind:src="item.customerthumbnail" width="70"></v-img>
              </template>
              <template v-slot:item.quantity="{ item }">
                {{ item.quantity!==undefined ? (item.quantity).toFixed(0) : '' }}
              </template>
              <template v-slot:item.amount="{ item }">
                {{ item.amount!==undefined ? (item.amount).toFixed(1) : '' }}
              </template>
              <template v-slot:item.lastOrderDate="{ item }">
              <p v-if="item.lastOrderDate!=undefined" class="two-line">{{ new Date(item.lastOrderDate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.lastUser="{ item }">
                <div v-if="item.lastUser!=undefined">
                <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.lastUser)['userimage']!==''" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.lastUser)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.lastUser)['username'][0].toUpperCase() : '' }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ users.length>0 ? users.find(user=>user._id == item.lastUser)['username'] : '' }} </span>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="findSalesSummaryDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Sales Summary</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="users.filter(x=>x.userstatus=='Active').map(x => {
                            return {text: x.username, value: x._id};
                          })"
                  v-model="query.userid"
                  v-on:input="checkSearchText2"
                  label="Sales Rep"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="regions.filter(x=>x.regionstatus=='Active').map(x => {
                            return {text: x.regionname, value: x._id};
                          })"
                  v-model="query.regionid"
                  v-on:input="checkSearchText2"
                  label="Region"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="townships.filter(x=>x.townshipstatus=='Active').map(x => {
                            return {text: x.townshipname, value: x._id};
                          })"
                  v-model="query.townshipid"
                  v-on:input="checkSearchText2"
                  label="Township"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  class="mb-4"
                  v-model="query.searchtext"
                  v-on:input="checkSearchText"
                  outlined
                  placeholder="Search Customer"
                  persistent-hint
                  single-line hint="Search Customer">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="query = {}"
          >
            Clear
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesSummaryDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findSalesSummary"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';



export default {
  name: 'SalesSummaryByItem',
  data() {
    return {
      headers: [
        { text: 'Image', value: 'customerthumbnail', width: '8%'},
        { text: 'Name', value: 'customername' },
        { text: 'Num of Visits', value: 'visitCount' },
        { text: 'Num of Orders', value: 'orderCount' },
        { text: 'Unit Qty', value: 'quantity' },
        { text: 'Total Sales', value: 'amount' },
        { text: 'Last Order', value: 'lastOrderDate' },
        { text: 'Sales Rep', value: 'lastUser' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      findSalesSummaryDialog: false,
      query: {},
      salessummaries: [],
      menu_startdate: null,
      menu_enddate: null,
      offset: 0,
    }
  },
  computed: {
    ...mapState('SalesSummary', ['isDeleting', 'isReceiving']),
    ...mapState('Customer', ['customers']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  async created () {
    if(this.regions.length==0) this.getRegionsRequest();
    if(this.townships.length==0) this.getTownshipsRequest();
    if(this.users.length==0) this.getUsersRequest();
  },
  methods: {
    ...mapActions('Customer', ["getCustomersAllRequest"]),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    ...mapActions('SalesSummary', ["getSalesSummaryByCustomer", "getSalesSummaryByCustomerSearch"]),
    checkSearchText(){
      if(this.query.searchtext.length>0){
        this.query.townshipid = null;
        this.query.regionid = null;
        this.query.userid = null;
      }
    },
    checkSearchText2(){
      if(this.query.regionid!=null) this.query.searchtext = '';
      if(this.query.townshipid!=null) this.query.searchtext = '';
      if(this.query.userid!=null) this.query.searchtext = ''; 
    },
    async findSalesSummary(){
      this.findSalesSummaryDialog = false;
      let results;
      if(this.query.searchtext) results = await this.getSalesSummaryByCustomerSearch(this.query);
      else results = await this.getSalesSummaryByCustomer(this.query);
      this.salessummaries = [];
      for(var i=0; i<results.length; i++){
        let result = results[i];       
        if(result.customerSummary!=undefined){
          let item = Object.assign({}, result);
          let keys = Object.keys(result.customerSummary)
          for(var j=0; j<keys.length; j++){
            let key = keys[j];
            item[key] = result.customerSummary[key];
          }
          delete item['customerSummary'];
          this.salessummaries.push(item);
        }
      }
      this.salessummaries.push({
        quantity: this.salessummaries.reduce(function (last, json) {return last + json.quantity;}, 0),
        amount: this.salessummaries.reduce(function (last, json) {return last + json.amount;}, 0),
        orderCount: this.salessummaries.reduce(function (last, json) {return last + json.orderCount;}, 0),
        visitCount: this.salessummaries.reduce(function (last, json) {return last + json.visitCount;}, 0),
      });
    },
    getJson(){
      let json = this.salessummaries.map(report=>{return {
        customername: report.customername, 
        customeraddress: report.customeraddress,
        region: report.regionid!=undefined && this.regions.length>0 ? this.regions.find(region=>region._id == report.regionid)['regionname'] : '',
        township: report.townshipid!=undefined && this.townships.length>0 ? this.townships.find(town=>town._id == report.townshipid)['townshipname'] : '',
        visitCount: report.visitCount,
        ordercount: report.orderCount,
        quantity: report.quantity, 
        amount: report.amount,
        lastorderdate: report.lastOrderDate!=null ? new Date(report.lastOrderDate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }) : '',
        salesrep: report.lastUser!=undefined && this.users.length>0 ? this.users.find(user=>user._id == report.lastUser)['username'] : '',
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-summary-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
